import { render, staticRenderFns } from "./Parcels_Poly.vue?vue&type=template&id=2e8563fd"
import script from "./Parcels_Poly.vue?vue&type=script&lang=js"
export * from "./Parcels_Poly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports